<template>
  <div class="container txt-black full">
    <div v-if="user">
      <div class="flex items-center space-x-3">
        <div>
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.58 11.4709C15.0345 10.9028 15.2846 10.1984 15.29 9.4709C15.29 8.59834 14.9434 7.76151 14.3264 7.14452C13.7094 6.52752 12.8726 6.1809 12 6.1809C11.1274 6.1809 10.2906 6.52752 9.67362 7.14452C9.05662 7.76151 8.71 8.59834 8.71 9.4709C8.71542 10.1984 8.96551 10.9028 9.42 11.4709C8.52863 12.0133 7.8293 12.8211 7.42 13.7809C7.36271 13.9027 7.3306 14.0348 7.32558 14.1693C7.32056 14.3037 7.34274 14.4379 7.39079 14.5636C7.43884 14.6893 7.51177 14.804 7.60521 14.9009C7.69865 14.9977 7.81068 15.0747 7.93459 15.1272C8.0585 15.1798 8.19174 15.2067 8.32632 15.2066C8.4609 15.2064 8.59406 15.179 8.71782 15.1261C8.84157 15.0732 8.95338 14.9959 9.04655 14.8988C9.13971 14.8017 9.21231 14.6867 9.26 14.5609C9.48983 14.0236 9.87157 13.5652 10.3583 13.2419C10.8451 12.9186 11.4157 12.7444 12 12.7409C12.586 12.7425 13.1588 12.9157 13.6475 13.2392C14.1362 13.5626 14.5195 14.0221 14.75 14.5609C14.8266 14.7416 14.9546 14.8959 15.1182 15.0043C15.2818 15.1128 15.4737 15.1707 15.67 15.1709C15.8038 15.1684 15.936 15.1413 16.06 15.0909C16.3039 14.9873 16.4966 14.7912 16.596 14.5455C16.6954 14.2999 16.6932 14.0249 16.59 13.7809C16.1781 12.8196 15.4751 12.0117 14.58 11.4709ZM12 10.7409C11.7444 10.7409 11.4946 10.665 11.2823 10.5228C11.0699 10.3806 10.9046 10.1785 10.8073 9.94222C10.7099 9.70592 10.685 9.44604 10.7356 9.19553C10.7862 8.94503 10.91 8.71519 11.0914 8.53519C11.2728 8.35518 11.5036 8.23312 11.7545 8.18448C12.0054 8.13584 12.2651 8.16282 12.5006 8.26199C12.7362 8.36116 12.9369 8.52806 13.0775 8.74151C13.218 8.95496 13.292 9.20534 13.29 9.4609C13.2874 9.80129 13.1503 10.1268 12.9087 10.3666C12.667 10.6064 12.3404 10.7409 12 10.7409ZM18 2.1709H6C5.20435 2.1709 4.44129 2.48697 3.87868 3.04958C3.31607 3.61219 3 4.37525 3 5.1709V16.1709C3 16.9665 3.31607 17.7296 3.87868 18.2922C4.44129 18.8548 5.20435 19.1709 6 19.1709H8.59L11.29 21.8809C11.3834 21.9736 11.4943 22.0469 11.6161 22.0967C11.7379 22.1464 11.8684 22.1717 12 22.1709C12.2383 22.1709 12.4689 22.0858 12.65 21.9309L15.87 19.1709H18C18.7956 19.1709 19.5587 18.8548 20.1213 18.2922C20.6839 17.7296 21 16.9665 21 16.1709V5.1709C21 4.37525 20.6839 3.61219 20.1213 3.04958C19.5587 2.48697 18.7956 2.1709 18 2.1709ZM19 16.1709C19 16.4361 18.8946 16.6905 18.7071 16.878C18.5196 17.0655 18.2652 17.1709 18 17.1709H15.5C15.2617 17.1709 15.0311 17.256 14.85 17.4109L12.05 19.8109L9.71 17.4609C9.61656 17.3682 9.50574 17.2949 9.38391 17.2451C9.26207 17.1954 9.13161 17.1701 9 17.1709H6C5.73478 17.1709 5.48043 17.0655 5.29289 16.878C5.10536 16.6905 5 16.4361 5 16.1709V5.1709C5 4.90568 5.10536 4.65133 5.29289 4.46379C5.48043 4.27626 5.73478 4.1709 6 4.1709H18C18.2652 4.1709 18.5196 4.27626 18.7071 4.46379C18.8946 4.65133 19 4.90568 19 5.1709V16.1709Z"
              fill="#20419B"
            />
          </svg>
        </div>
        <div class="fs-22 fw-500">{{ user.name }}</div>
        <span v-if="isImgPackage">
          <img class="h-9" :src="getUrlImg(isImgPackage)" alt />
        </span>
        <div v-else-if="isPendingOrder" class="bg-pending-order">Đang chờ xác nhận</div>
      </div>
      <div class="fs-16 fw-400 my-2">{{ getInfo() }}</div>
    </div>
    <div class="row mt-3" v-if="(diseases && diseases.data && diseases.data.length)">
      <div
        class="col-md-4 flex flex-col items-center text-center space-y-10 text-pri-900 fs-16 fw-500"
      >
        <div class="cursor-pointer" @click="goToCreate()">
          <img src="../../assets/icon/AddHSSK.svg" alt />
          <div>Tạo mới Hồ sơ Sức khỏe</div>
        </div>
        <!-- <div
          class="cursor-pointer"
          @click="goToHR()"
        ><img
            src="../../assets/icon/SKB.svg"
            alt=""
          >
          <div>Sổ khám bệnh</div>
        </div>-->
      </div>
      <div class="col-md-8">
        <p class="fs-28 fw-500 mb-3" v-if="!loading">Danh sách Hồ Sơ Sức Khỏe</p>
        <div>
          <div class="item" v-for="disease in diseases.data" :key="disease.id">
            <div class="d-flex justify-between items-center">
              <div class="flex">
                <div class="me-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.07 6.25 8.66 5.84C8.25 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z"
                      fill="#476DD6"
                    />
                    <path
                      d="M18.83 5.02996C18.6 4.83996 18.34 4.68996 18.06 4.57996C17.77 4.46996 17.48 4.69996 17.42 4.99996C17.08 6.70996 15.57 7.99996 13.75 7.99996H10.25C9.25 7.99996 8.31 7.60996 7.6 6.89996C7.08 6.37996 6.72 5.71996 6.58 5.00996C6.52 4.70996 6.22 4.46996 5.93 4.58996C4.77 5.05996 4 6.11996 4 8.24996V18C4 21 5.79 22 8 22H16C18.21 22 20 21 20 18V8.24996C20 6.61996 19.55 5.61996 18.83 5.02996ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
                      fill="#476DD6"
                    />
                  </svg>
                </div>
                <div>
                  <p class="fs-18 fw-500 txt-black mb-1 max-max-line-2">{{ disease.diseases_name }}</p>
                  <p class="fs-18 fw-400 txt-black mb-1 max-max-line-1">{{ disease.diseases_stage }}</p>
                </div>
              </div>
              <div class="flex space-x-5">
                <div
                  class="d-flex flex-col justify-content-end align-items-center w-20"
                  @click="goToDisease(disease.id, true)"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      x="0.625651"
                      y="1.01969"
                      width="27.4167"
                      height="27.4167"
                      rx="13.7083"
                      stroke="#20419B"
                      stroke-width="0.583333"
                    />
                    <rect
                      x="4.40991"
                      y="6.72803"
                      width="19.8481"
                      height="16"
                      fill="url(#pattern0)"
                    />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlink:href="#image0_16576_67438"
                          transform="scale(0.0102041 0.0126582)"
                        />
                      </pattern>
                      <image
                        id="image0_16576_67438"
                        width="98"
                        height="79"
                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABPCAYAAAAQlxDmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARYSURBVHgB7d1NaBxlHMfx3zOz291mjRmj2LhIOmJAAmnagp4U3BRLAmKreBRtFETE2C4eAp66q7eKtLX1NQeTs6DxUldEs4IXRZJotRZMYdJLX1LaDTShTTL7dJ5pst0m2bfJ7s5/m//nkszLJmG+mWfy7EBGoAgz9rmpPmDDshkr/c4kGlAsPmEEF4Km1KTx04mukvvvffefgtuWAkuT6WO7M+ttC6xeYca+NqAtHYJE3Fk0UCVmz1AGQowiu5i00m9bIO65gdMxXQQOw5Yx6MC21mDJ11y6ughd6AW367aO3oNnJrMye9yJOpy/TeQvmLGvdjlrvnNWm6glgYT1y5tJEKTOgJAdPgrI/vz1KsRIoqPoa1WIA4kplEVgUizcfCn1xW5LLWor691hSIixmkdQJBLmnqHDIMaNkA2NrY5QExK7ZDA0pr6nWsyFgNCdH6B6Q1EZPwipGLkIzgFC/Zghe8tR9Yl7jXCGpP5qnAlRI4Noy7VKXpJ49f03jPf2nPoePvp5+nlj6K+QOiAm6k709w2cHrl9sRbaIfUr6tW+7gns3zmBJ7db8MD5o0DE4ZPL820Y/f8V+ElCf3H5rybp6XRsDt/Ahy98i54nzqIRqQjJ3z7GjPPRVxqe1ZbnCp4M7v2BI1SDhBGAR2o42ucMR43Ia4S/p+aLbr90dQHdHRGU/jpza9Z5D9GgEazZDnz0e7LiCGqOMPjJdNF9NjLX8BziKW8XZl+pCOpMmFu8D9R4ChFtyaDRnLmy0zkTPiAZQfF8RjQKdeBPnXsZ35x9DZQVDREKNyGwJQxdv3s3EW7Gr+d7Qdl1J4A1+zj+vPA02bMg35oQmnPQH3jwEbQ+FIWmFe706Xg3WPXcdaS3Ru7Ho9s7iwZgtZE74uGtEbQ/tgPMH24INRxF2zvBiis1WVPziHImfetxQzQ3tyIYDIEVpg7ykYPtRfep6MbQKu79CMO5MDN/aUabiXC49PsjrLa0NicE858GRgKHIIJDEMEhiOD3MipA8g7dZlPrO3Q8NBHBIYjgEERwCCI4BBEcgggOQQTPIypQ8zt0rLS63KFj/uMQRHAIIjgEERyCCA5BBIcggucRFeA7dATwHbpNgkMQwSGI4BBEcAgiOAQRHIIInkdsgNkyhUjwem5ZzSPszExu+fL8tjX/84Pv0FWZCnCk56016+fG73w+M9uBwbEvUQ4emjxqyjsTComUsc8KDkEEhyCCQxDBIYjgEERwCCI4BBEcgggOQQSHIIJDEMEhiOB3Xz1Sb2+nz/fi4aaLBff548IzKBeH2IDPxgdRLTw0USCQ0VLHOi0JNN4/+76XSDl9+4yQ8PUZP5udgBx1Q2iwh8H8YqVOdA27IVInd6Qhs8fB6k4g6z4YMXex/vFkV1xKjIDVjZAymVp+VKZYvbFv4N+EFOIAfHkm26ZhCWm/7o5Ey8R6e/XF/zNh2zEptf2o59Ma720ZZ/yZFll7ND/Ailurc2OYTH2NHwAAAABJRU5ErkJggg=="
                      />
                    </defs>
                  </svg>

                  <p class="fs-12 fw-400 txt-pri mb-0 me-2">Upload PACS</p>
                </div>
                <div
                  class="d-flex flex-col justify-content-end align-items-center w-20"
                  @click="goToDisease(disease.id)"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.625651"
                      y="1.01969"
                      width="27.4167"
                      height="27.4167"
                      rx="13.7083"
                      stroke="#20419B"
                      stroke-width="0.583333"
                    />
                    <path
                      d="M8.20898 14.1447C7.88682 14.1447 7.62565 14.4059 7.62565 14.728C7.62565 15.0502 7.88682 15.3114 8.20898 15.3114V14.1447ZM20.2881 15.1405C20.5159 14.9127 20.5159 14.5434 20.2881 14.3155L16.5758 10.6032C16.348 10.3754 15.9787 10.3754 15.7509 10.6032C15.5231 10.831 15.5231 11.2004 15.7509 11.4282L19.0507 14.728L15.7509 18.0279C15.5231 18.2557 15.5231 18.625 15.7509 18.8528C15.9787 19.0806 16.348 19.0806 16.5758 18.8528L20.2881 15.1405ZM8.20898 15.3114H19.8757V14.1447H8.20898V15.3114Z"
                      fill="#002496"
                    />
                  </svg>
                  <p class="fs-12 fw-400 txt-pri mb-0 me-2">Xem chi tiết</p>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            background
            layout="sizes, prev, pager, next"
            :total="pagination.total"
            class="flex justify-end"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.page_size"
          ></el-pagination>
          <div class="d-flex h-100 justify-content-center align-items-center py-5" v-if="loading">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="fs-16 fw-400 mt-3" v-if="!isMemberPackage">
        <div class="fs-20 fw-500">Người dùng mới sẽ được Hỗ trợ gói Silver bao gồm các ưu đãi sau</div>
        <div class="mt-3">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2502 19.1693L19.6002 19.5593C19.2302 19.6493 18.9402 19.9293 18.8602 20.2993L18.5102 21.7693C18.3202 22.5693 17.3002 22.8193 16.7702 22.1893L13.7802 18.7493C13.5402 18.4693 13.6702 18.0293 14.0302 17.9393C15.8002 17.5093 17.3902 16.5193 18.5602 15.1093C18.7502 14.8793 19.0902 14.8493 19.3002 15.0593L21.5202 17.2793C22.2802 18.0393 22.0102 18.9893 21.2502 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M2.70016 19.1693L4.35016 19.5593C4.72016 19.6493 5.01016 19.9293 5.09016 20.2993L5.44016 21.7693C5.63016 22.5693 6.65016 22.8193 7.18016 22.1893L10.1702 18.7493C10.4102 18.4693 10.2802 18.0293 9.92016 17.9393C8.15016 17.5093 6.56016 16.5193 5.39016 15.1093C5.20016 14.8793 4.86016 14.8493 4.65016 15.0593L2.43016 17.2793C1.67016 18.0393 1.94016 18.9893 2.70016 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M12 2.69922C8.13 2.69922 5 5.82922 5 9.69922C5 11.1492 5.43 12.4792 6.17 13.5892C7.25 15.1892 8.96 16.3192 10.95 16.6092C11.29 16.6692 11.64 16.6992 12 16.6992C12.36 16.6992 12.71 16.6692 13.05 16.6092C15.04 16.3192 16.75 15.1892 17.83 13.5892C18.57 12.4792 19 11.1492 19 9.69922C19 5.82922 15.87 2.69922 12 2.69922ZM15.06 9.47922L14.23 10.3092C14.09 10.4492 14.01 10.7192 14.06 10.9192L14.3 11.9492C14.49 12.7592 14.06 13.0792 13.34 12.6492L12.34 12.0592C12.16 11.9492 11.86 11.9492 11.68 12.0592L10.68 12.6492C9.96 13.0692 9.53 12.7592 9.72 11.9492L9.96 10.9192C10 10.7292 9.93 10.4492 9.79 10.3092L8.94 9.47922C8.45 8.98922 8.61 8.49922 9.29 8.38922L10.36 8.20922C10.54 8.17922 10.75 8.01922 10.83 7.85922L11.42 6.67922C11.74 6.03922 12.26 6.03922 12.58 6.67922L13.17 7.85922C13.25 8.01922 13.46 8.17922 13.65 8.20922L14.72 8.38922C15.39 8.49922 15.55 8.98922 15.06 9.47922Z"
              fill="#476DD6"
            />
          </svg>
          Liên lạc không giới hạn với Bác sĩ
        </div>
        <div class="mt-2">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2502 19.1693L19.6002 19.5593C19.2302 19.6493 18.9402 19.9293 18.8602 20.2993L18.5102 21.7693C18.3202 22.5693 17.3002 22.8193 16.7702 22.1893L13.7802 18.7493C13.5402 18.4693 13.6702 18.0293 14.0302 17.9393C15.8002 17.5093 17.3902 16.5193 18.5602 15.1093C18.7502 14.8793 19.0902 14.8493 19.3002 15.0593L21.5202 17.2793C22.2802 18.0393 22.0102 18.9893 21.2502 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M2.70016 19.1693L4.35016 19.5593C4.72016 19.6493 5.01016 19.9293 5.09016 20.2993L5.44016 21.7693C5.63016 22.5693 6.65016 22.8193 7.18016 22.1893L10.1702 18.7493C10.4102 18.4693 10.2802 18.0293 9.92016 17.9393C8.15016 17.5093 6.56016 16.5193 5.39016 15.1093C5.20016 14.8793 4.86016 14.8493 4.65016 15.0593L2.43016 17.2793C1.67016 18.0393 1.94016 18.9893 2.70016 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M12 2.69922C8.13 2.69922 5 5.82922 5 9.69922C5 11.1492 5.43 12.4792 6.17 13.5892C7.25 15.1892 8.96 16.3192 10.95 16.6092C11.29 16.6692 11.64 16.6992 12 16.6992C12.36 16.6992 12.71 16.6692 13.05 16.6092C15.04 16.3192 16.75 15.1892 17.83 13.5892C18.57 12.4792 19 11.1492 19 9.69922C19 5.82922 15.87 2.69922 12 2.69922ZM15.06 9.47922L14.23 10.3092C14.09 10.4492 14.01 10.7192 14.06 10.9192L14.3 11.9492C14.49 12.7592 14.06 13.0792 13.34 12.6492L12.34 12.0592C12.16 11.9492 11.86 11.9492 11.68 12.0592L10.68 12.6492C9.96 13.0692 9.53 12.7592 9.72 11.9492L9.96 10.9192C10 10.7292 9.93 10.4492 9.79 10.3092L8.94 9.47922C8.45 8.98922 8.61 8.49922 9.29 8.38922L10.36 8.20922C10.54 8.17922 10.75 8.01922 10.83 7.85922L11.42 6.67922C11.74 6.03922 12.26 6.03922 12.58 6.67922L13.17 7.85922C13.25 8.01922 13.46 8.17922 13.65 8.20922L14.72 8.38922C15.39 8.49922 15.55 8.98922 15.06 9.47922Z"
              fill="#476DD6"
            />
          </svg>
          Lưu trữ và tải xuống tài liệu Chẩn đoán hình ảnh (CT, MRI, PET/CT)
        </div>
        <div class="mt-2">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2502 19.1693L19.6002 19.5593C19.2302 19.6493 18.9402 19.9293 18.8602 20.2993L18.5102 21.7693C18.3202 22.5693 17.3002 22.8193 16.7702 22.1893L13.7802 18.7493C13.5402 18.4693 13.6702 18.0293 14.0302 17.9393C15.8002 17.5093 17.3902 16.5193 18.5602 15.1093C18.7502 14.8793 19.0902 14.8493 19.3002 15.0593L21.5202 17.2793C22.2802 18.0393 22.0102 18.9893 21.2502 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M2.70016 19.1693L4.35016 19.5593C4.72016 19.6493 5.01016 19.9293 5.09016 20.2993L5.44016 21.7693C5.63016 22.5693 6.65016 22.8193 7.18016 22.1893L10.1702 18.7493C10.4102 18.4693 10.2802 18.0293 9.92016 17.9393C8.15016 17.5093 6.56016 16.5193 5.39016 15.1093C5.20016 14.8793 4.86016 14.8493 4.65016 15.0593L2.43016 17.2793C1.67016 18.0393 1.94016 18.9893 2.70016 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M12 2.69922C8.13 2.69922 5 5.82922 5 9.69922C5 11.1492 5.43 12.4792 6.17 13.5892C7.25 15.1892 8.96 16.3192 10.95 16.6092C11.29 16.6692 11.64 16.6992 12 16.6992C12.36 16.6992 12.71 16.6692 13.05 16.6092C15.04 16.3192 16.75 15.1892 17.83 13.5892C18.57 12.4792 19 11.1492 19 9.69922C19 5.82922 15.87 2.69922 12 2.69922ZM15.06 9.47922L14.23 10.3092C14.09 10.4492 14.01 10.7192 14.06 10.9192L14.3 11.9492C14.49 12.7592 14.06 13.0792 13.34 12.6492L12.34 12.0592C12.16 11.9492 11.86 11.9492 11.68 12.0592L10.68 12.6492C9.96 13.0692 9.53 12.7592 9.72 11.9492L9.96 10.9192C10 10.7292 9.93 10.4492 9.79 10.3092L8.94 9.47922C8.45 8.98922 8.61 8.49922 9.29 8.38922L10.36 8.20922C10.54 8.17922 10.75 8.01922 10.83 7.85922L11.42 6.67922C11.74 6.03922 12.26 6.03922 12.58 6.67922L13.17 7.85922C13.25 8.01922 13.46 8.17922 13.65 8.20922L14.72 8.38922C15.39 8.49922 15.55 8.98922 15.06 9.47922Z"
              fill="#476DD6"
            />
          </svg>
          Chuyển đổi số các thông tin sức khỏe từ hình ảnh
        </div>
        <div class="mt-2">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2502 19.1693L19.6002 19.5593C19.2302 19.6493 18.9402 19.9293 18.8602 20.2993L18.5102 21.7693C18.3202 22.5693 17.3002 22.8193 16.7702 22.1893L13.7802 18.7493C13.5402 18.4693 13.6702 18.0293 14.0302 17.9393C15.8002 17.5093 17.3902 16.5193 18.5602 15.1093C18.7502 14.8793 19.0902 14.8493 19.3002 15.0593L21.5202 17.2793C22.2802 18.0393 22.0102 18.9893 21.2502 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M2.70016 19.1693L4.35016 19.5593C4.72016 19.6493 5.01016 19.9293 5.09016 20.2993L5.44016 21.7693C5.63016 22.5693 6.65016 22.8193 7.18016 22.1893L10.1702 18.7493C10.4102 18.4693 10.2802 18.0293 9.92016 17.9393C8.15016 17.5093 6.56016 16.5193 5.39016 15.1093C5.20016 14.8793 4.86016 14.8493 4.65016 15.0593L2.43016 17.2793C1.67016 18.0393 1.94016 18.9893 2.70016 19.1693Z"
              fill="#476DD6"
            />
            <path
              d="M12 2.69922C8.13 2.69922 5 5.82922 5 9.69922C5 11.1492 5.43 12.4792 6.17 13.5892C7.25 15.1892 8.96 16.3192 10.95 16.6092C11.29 16.6692 11.64 16.6992 12 16.6992C12.36 16.6992 12.71 16.6692 13.05 16.6092C15.04 16.3192 16.75 15.1892 17.83 13.5892C18.57 12.4792 19 11.1492 19 9.69922C19 5.82922 15.87 2.69922 12 2.69922ZM15.06 9.47922L14.23 10.3092C14.09 10.4492 14.01 10.7192 14.06 10.9192L14.3 11.9492C14.49 12.7592 14.06 13.0792 13.34 12.6492L12.34 12.0592C12.16 11.9492 11.86 11.9492 11.68 12.0592L10.68 12.6492C9.96 13.0692 9.53 12.7592 9.72 11.9492L9.96 10.9192C10 10.7292 9.93 10.4492 9.79 10.3092L8.94 9.47922C8.45 8.98922 8.61 8.49922 9.29 8.38922L10.36 8.20922C10.54 8.17922 10.75 8.01922 10.83 7.85922L11.42 6.67922C11.74 6.03922 12.26 6.03922 12.58 6.67922L13.17 7.85922C13.25 8.01922 13.46 8.17922 13.65 8.20922L14.72 8.38922C15.39 8.49922 15.55 8.98922 15.06 9.47922Z"
              fill="#476DD6"
            />
          </svg>
          <span class="text-red-500 ml-1">5GB</span> lưu trữ dữ liệu trên HODO Cloud
        </div>
      </div>
      <div class="flex justify-around items-center text-center text-pri-900 fs-16 fw-500 mt-3">
        <div class="cursor-pointer" @click="goToCreate()">
          <img src="../../assets/icon/AddHSSK.svg" alt />
          <div class="mt-3">Quản lý Hồ sơ sức khỏe</div>
        </div>
        <div class="cursor-pointer" @click="goToHR()">
          <img src="../../assets/icon/SKB.svg" alt />
          <div class="mt-3">Sổ khám bệnh</div>
        </div>
        <div class="cursor-pointer" @click="goToCreate(true)">
          <img class="mt-3 pt-1" src="../../assets/icon/UploadPACS.svg" alt />
          <div class="mt-3">Upload tài liệu Chẩn đoán hình ảnh</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import appUtils from '../../utils/appUtils'
export default {
  name: 'ListDiseases',
  data () {
    return {
      diseases: [],
      loading: false,
      user: null,
      pagination: {
        page_size: 10,
        page_num: 1,
        total: 0
      }
    }
  },
  computed: {
    isMemberPackage () {
      const redeemPackage = this.user?.redeem_package
      if (redeemPackage) {
        return redeemPackage
      }
      const packages = this.user?.user_packages || []
      const result = packages?.find(item => {
        return (
          item.member_package?.code.toUpperCase() === 'HODO GOLD' ||
          item.member_package?.code.toUpperCase() === 'HODO GOLD PLUS' ||
          item.member_package?.code.toUpperCase() === 'HODO SILVER PLUS'
        )
      })
      return result
    },
    isImgPackage () {
      const pac = this.user?.redeem_package
      if (pac) {
        return pac.package_icon
      }
      const packages = this.user?.user_packages || []
      let result = packages?.find(item => {
        return (
          item.member_package?.code.toUpperCase() === 'HODO GOLD' ||
          item.member_package?.code.toUpperCase() === 'HODO GOLD PLUS'
        )
      })
      if (!result) {
        result = packages?.find(item => {
          return item.member_package?.code.toUpperCase() === 'HODO SILVER PLUS'
        })
      }
      return result && result.member_package?.package_icon
    },
    isPendingOrder () {
      return this.user?.is_pending_order
    }
  },
  mounted () {
    const self = this
    self.getUserInfo()
    self.user = this.$user
  },
  methods: {
    async getUserInfo () {
      const self = this
      self.loading = true
      await self.$rf
        .getRequest('AuthRequest')
        .me()
        .then(resp => {
          self.person = resp.data?.person
          console.log(resp.data)
          if (resp.data?.doctor || resp.data?.clinic) {
            appUtils.removeLocalUser()
            appUtils.removeLocalToken()
            window.location.reload()
          } else if (!resp.data?.person) {
            self.$router.push({ path: '/tai-khoan-moi' })
          } else {
            self.getDiseases()
            appUtils.setLocalUser(resp.data)
            self.user = this.$user
          }
          // console.log(resp)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          self.loading = false
        })
    },
    async getDiseases () {
      const self = this
      const params = {
        page_num: this.pagination.page_num,
        page_size: this.pagination.page_size,
        sort_by: 'updated_at',
        order: 'desc'
      }
      await self.$rf
        .getRequest('AuthRequest')
        .getDiseasesV2(params)
        .then(resp => {
          self.diseases = resp?.data || null
          self.pagination.total = resp?.data?.page?.total
          console.log(resp)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
    goToDisease (id, uploadPacs) {
      if (uploadPacs) {
        this.$router.push({
          path: `/hssk/${id}/view`,
          query: { type: 'uploadPacs' }
        })
      } else this.$router.push({ path: `/hssk/${id}/view` })
    },
    goToCreate (uploadPacs) {
      if (uploadPacs) {
        this.$router.push({
          path: '/hssk/tao-ho-so-suc-khoe',
          query: { type: 'uploadPacs' }
        })
      } else this.$router.push({ path: '/hssk/tao-ho-so-suc-khoe' })
    },
    getInfo () {
      let result = ''
      if (this.user.person?.birthday) {
        result = `Ngày sinh: ${moment(this.user.person.birthday).format(
          'DD/MM/YYYY'
        )}`
      }
      if (this.user.person?.phone) {
        result = `${result}, SĐT: ${this.user.person.phone}`
      }
      if (this.user.person?.address) {
        result = `${result}, Đ/C: ${this.user.person.address}`
      }
      return result
    },
    getUrlImg (path) {
      return appUtils.getDocumentURL(path)
    },
    goToHR () {
      this.$router.push({ path: '/health-records' })
    },
    handleSizeChange (value) {
      this.pagination.page_size = value
      this.pagination.page_num = 1
      this.getDiseases()
    },
    handleCurrentChange (value) {
      this.pagination.page_num = value
      this.getDiseases()
    }
  }
}
</script>

<style scoped>
.full {
  min-height: calc(100vh - 150px);
}

.item {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  cursor: pointer;
}

.btn-add {
  height: 70px;
  width: 100%;
  border: 1px dashed #20409b;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px;
  cursor: pointer;
}

.bg-pending-order {
  background: #ffbc99;
  border-radius: 16px;
  padding: 0 12px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
</style>
